import styled from "styled-components";
import { theme } from "@themes";

export const ButtonCancel = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primaryBorder};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonCreate = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 100%;
  height: 43.21px;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ContentCreate = styled.div`
  display: grid;
  grid-gap: 1em;
  padding: 2em;
`;
export const ContentFields = styled.div`
  display: grid;
  grid-gap: 1em;
`;
export const ContentField = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  grid-auto-rows: 1em auto;
  align-items: center;
  width: 100%;
  label {
    grid-column: 1/3;
    color: rgba(123, 123, 123, 1);
    font-size: 14px;
  }
`;
export const ContentButtons = styled.div`
  width: 19em;
  display: flex;
  grid-gap: 1em;
`;
export const ContentFile = styled.div`
  width: 100%;
  height: 12em;
  margin: auto;
`;
export const AccordeonLine = styled.div`
  background: radial-gradient(#ada9a9, transparent);
  width: 86%;
  height: 1px;
  margin: auto;
`;
export const FieldFile = styled.div`
  height: 12em;
  display: grid;
  grid-auto-rows: 0em auto;
  label {
    color: rgb(143, 155, 179);
  }
`;
export const ContentSetHours = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 1em;
`;
export const ContentResume = styled.div`
  grid-column: 1/5;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14vw, 1fr));
  width: 100%;
  text-align: center;
  grid-gap: 1em;
`;
export const InfoHours = styled.div`
  display: grid;
  grid-template-columns: 6fr 1fr;
  svg {
    color: ${({ theme }) => theme.neutral.gray[1400]};
    cursor: pointer;
  }
  svg:hover {
    color: ${({ theme }) => theme.neutral.gray[2800]};
  }
`;
export const ButtonAddHours = styled.div`
  margin: auto;
  svg {
    font-size: 3em;
    color: ${({ theme }) => theme.primary.purple};
    cursor: pointer;
    border-radius: 26px;
  }
  svg:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
  }
`;
export const CopyHours = styled.div`
  svg {
    float: right;
    font-size: 21px;
    margin-right: 4px;
    color: rgb(156, 150, 150);
    cursor: pointer;
  }
  svg:hover {
    color: ${({ theme }) => theme.neutral.gray[3200]} !important;
  }
`;
export const CardHours = styled.div`
  background: ${({ theme }) => theme.neutral.gray[100]};
  padding: 0.5em;
  border-radius: 5px;
  box-shadow: -4px 4px 0px 0px rgb(161 159 161 / 26%);
`;

export const ContentCopy = styled.div`
  background: ${({ theme }) => theme.neutral.white};
  width: 26em;
  display: grid;
  grid-auto-rows: 2em 8em 3em;
  padding: 1em;
  border-radius: 7px;
  margin: 9em auto;
`;
export const ButtonsCopy = styled.div`
  width: 14em;
  display: inline-flex;
  margin: auto;
  grid-gap: 1em;
`;
export const ContainFormCheck = styled.div`
  margin: 4px;
  background-color: ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 99px;
  float: left;
  width: 3em;
  height: 3em;
  &:hover {
    background: ${({ theme }) => theme.primary.purple};
    cursor: pointer;
    color: ${({ theme }) => theme.neutral.white};
  }
`;

export const FormLabelCheck = styled.label`
  float: left;
  width: 3em;
  cursor: pointer;
  span {
    text-align: center;
    padding: 11px 0px;
    display: block;
  }
`;

export const FormForCheck = styled.input`
  display: none;
  &:checked + span {
    background-color: ${({ theme }) => theme.primary.purple};
    border-radius: 99px;
    color: ${({ theme }) => theme.neutral.white};
    height: 3em;
  }
`;
